<template>
	<div class="import" id="import" v-loading="loadingImportErrors">
		<ErrorResolutionTable v-if="!loadingImportErrors"/>
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import ErrorResolutionTable from './resolveErrors/ErrorResolutionTable'

export default {
	name: 'resolve-import-errors',
    computed: {
        ...mapState('provider', [
			'importErrors',
			'loadingImportErrors'
        ])
    },
	components: {
		ErrorResolutionTable
	}
}
</script>

<style scoped>
	.import {
		padding: 0px 20px 14px 20px;
	}
</style>